import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	markedAsDoneFlagTitle: {
		id: 'business-list.list-view.status-cell.marked-as-done-flag-title',
		defaultMessage: 'Nice one!',
		description: 'Title celebrating that an issue was completed',
	},
	markedAsDone: {
		id: 'business-list.list-view.status-cell.marked-as-done',
		defaultMessage: 'Marked "{issue}" as {statusName}',
		description: 'Message with details of the completed issue',
	},
	viewIssue: {
		id: 'business-list.list-view.status-cell.view-issue',
		defaultMessage: 'View issue',
		description: 'Link text to redirect user to view issue',
	},
	markedAsDoneOld: {
		id: 'business-list.list-view.status-cell.marked-as-done-old',
		defaultMessage: 'Marked {link} as {statusName}',
		description: 'Message with details of the completed issue',
	},
	placeholder: {
		id: 'business-list.list-view.status-cell.placeholder',
		defaultMessage: 'Select Status',
		description: 'Status picker placeholder text.',
	},
	cannotLoadTransitions: {
		id: 'business-list.list-view.status-cell.cannot-load-transitions',
		defaultMessage: "Couldn't load the statuses.",
		description: 'Message shown when we failed to load transitions from backend',
	},
	noSearchResults: {
		id: 'business-list.list-view.status-cell.no-search-results',
		defaultMessage: "It looks like we can't find any statuses that match.",
		description:
			'Message shown when user has typed to filter in status select and there are no matching results',
	},
	viewIssueIssueTermRefresh: {
		id: 'business-list.list-view.status-cell.view-issue-issue-term-refresh',
		defaultMessage: 'View work item',
		description: 'Link text to redirect user to view issue',
	},
	createStatus: {
		id: 'business-list.list-view.status-cell.create-status',
		defaultMessage: 'Create status',
		description: 'Option label value to create a new issue status',
	},
});
